<template>
  <div>
    <v-card
      tile
      elevation="0"
      class="d-flex flex-column justify-center py-12"
      :min-height="settings.bg && settings.bg.height ? settings.bg.height : '700px'"
      :color="MIXIN_getBgInfo(settings, 'color')"
      :img="MIXIN_getBgInfo(settings, 'image')"
    >
      <section>
        <title-component
          v-if="alignCenter || !$vuetify.breakpoint.mdAndUp"
          :settings="{...settingsTitle, idLayout: settings.idLayout}"
        />

        <v-container style="max-width: 1340px">
          <v-row
            v-if="!$vuetify.breakpoint.mdAndUp || alignCenter"
            justify="center"
            :class="$vuetify.breakpoint.mdAndUp ? 'pb-6' : 'pb-6 px-6'"
            :style="$vuetify.breakpoint.mdAndUp ? 'padding: 0px 150px' : ''"
          >
            <span class="pt-6 pb-0" v-html="formatedText"></span>
          </v-row>

          <v-row
            :class="
              $vuetify.breakpoint.mdAndUp ? (alignCenter ? 'pa-2' : 'pa-12') : 'px-4'
            "
            justify="center"
            no-gutters
            :style="`${settings['text-position'] === 'right' ? 'flex-direction: row-reverse !important' : ''}`"
          >
            <v-col
              v-if="!alignCenter"
              :class="$vuetify.breakpoint.mdAndUp ? 'px-12' : ''"
              :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
            >
              <v-row v-if="$vuetify.breakpoint.mdAndUp" justify="start">
                <h1
                  :style="
                    `
                    font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
                    font-size: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
                    color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
                    line-height: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
                    font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
                    font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
                    `
                  "
                >
                  {{ settings.title.content }}
                </h1>
              </v-row>
              <v-row
                v-if="$vuetify.breakpoint.mdAndUp"
                :justify="$vuetify.breakpoint.mdAndUp ? 'start' : 'center'"
                :class="
                  $vuetify.breakpoint.mdAndUp ? 'mt-10 pr-12' : 'pb-12 px-8'
                "
              >
                <span v-html="formatedText"></span>
              </v-row>
            </v-col>

            <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'">
              <v-card
                :color="settings['layer-color']"
                :class="$vuetify.breakpoint.mdAndUp ? 'pa-12 rounded-xl' : 'pa-10 py-10 rounded-xl'"
                elevation="0"
              >
                <v-form ref="form">
                  <v-row
                    v-for="(item, i) in settings.items"
                    :key="i"
                    justify="center"
                    align="center"
                  >
                    <div v-if="item.type === 'text'" style="width: 100%">
                      <span
                        class="item-title mb-4"
                        :style="`color: ${settings['text-color']}`"
                        >{{ item.caption }}</span
                      >
                      <v-text-field
                        outlined
                        :rules="[rules.required]"
                        color="grey"
                        background-color="white"
                        v-model="name"
                      ></v-text-field>
                    </div>
                    <div v-if="item.type === 'email'" style="width: 100%">
                      <span
                        class="item-title mb-4"
                        :style="`color: ${settings['text-color']}`"
                        >{{ item.caption }}</span
                      >
                      <v-text-field
                        :rules="[rules.email, rules.required]"
                        outlined
                        color="grey"
                        background-color="white"
                        v-model="email"
                      ></v-text-field>
                    </div>
                    <div v-if="item.type === 'phone'" style="width: 100%">
                      <span
                        class="item-title mb-4"
                        :style="`color: ${settings['text-color']}`"
                        >{{ item.caption }}</span
                      >
                      <v-text-field
                        outlined
                        color="grey"
                        :rules="[rules.required]"
                        background-color="white"
                        v-mask="phone.length <= 14 ? maskPhone : maskCellPhone"
                        v-model="phone"
                      ></v-text-field>
                    </div>
                    <v-btn
                      elevation="0"
                      dark
                      :style="
                        `
                        background-color: ${MIXIN_getStyle(settings, 'button', 'background-color')} !important;
                        border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius')} !important;
                        `
                      "
                      :loading="loading"
                      v-if="item.type === 'submit'"
                      width="100%"
                      @click="submitContact"
                      >
                      <b 
                        :style="
                          `
                          color: ${MIXIN_getStyle(settings, 'button', 'color')} !important;
                          `
                        "
                      >
                        Cadastrar
                        </b>
                      </v-btn>
                  </v-row>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </v-card>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import TitleComponent from "../title/TitleComponent.vue";
import {GetLayoutSectionMixin} from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],
  components: { TitleComponent },
  directives: { mask },
  props: {
    settings: {type: Object}
  },

  data() {
    return {
      maskPhone: "(##) ####-####",
      maskCellPhone: "(##) #####-####",
      settingsTitle: null,
      dialogMessage: false,
      name: "",
      message: "",
      hover: false,
      email: "",
      phone: "",
      loading: false,
      rules: {
        required: (value) => !!value || "Este campo é obrigatório.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail Inválido.";
        },
      },
    };
  },

  computed: {
    ...mapGetters(["infos"]),
    alignCenter() {
      if (this.settings["text-position"] === "center") return true;
      else false;
    },

    formatedText() {
      if (this.settings.text.content) {
        let content = this.settings.text.content 
        if (!content.includes('<p>') && !content.includes('</p>')) content = `<p>${content}</p>`
        const formated = content
          .replaceAll(
            '<p>',
            `<span style="
              display: block;
              font-family: ${this.MIXIN_getStyle(this.settings, 'text', 'font')} !important; 
              font-size: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              color: ${this.MIXIN_getStyle(this.settings, 'text', 'color')} !important; 
              line-height: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              font-weight: ${this.MIXIN_getStyle(this.settings, 'text', 'weight')} !important;
              font-style: ${this.MIXIN_getStyle(this.settings, 'text', 'font-style')} !important;
            ">`
          )
          .replaceAll('</p>', "</span>")
        return formated
      } else return ""
    }    
  },

  created() {
    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };
  },

  methods: {
    async submitContact() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        await this.$store
          .dispatch("registerCampaign", {
            event: this.infos["event-id"],
            name: this.name,
            email: this.email,
            phone: this.phone,
            token: this.$route?.query?.c
              ? this.$route?.query?.c
              : this.settings.token,
          })
          .then((resp) => {
            this.loading = false;
            this.clearForm();
            this.$refs.form.resetValidation();
          })
          .catch((e) => {
            this.loading = false;
            this.clearForm();
            this.$refs.form.resetValidation();
          });
        this.clearForm();
        this.$refs.form.resetValidation();
        this.loading = false;
      } else {
        this.$store.commit("SET_SNACKBAR", {
          open: true,
          message: "Preencha todos os campos.",
          color: "red",
        });
        this.loading = false;
      }
    },

    closeDialog() {
      this.dialogMessage = false;
    },

    clearForm() {
      this.name = "";
      this.email = "";
      this.phone = "";
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: left;
}

span {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
}

.v-btn {
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.75px;
  text-align: center;
}

.item-title {
  font-size: 16px;
}
</style>
